import type { Candidate } from '../types/domain';

export const PUBLIC_DEMO_CODE = 'MOCK-2026';

export const DEMO_CANDIDATE = Object.freeze({
  name: 'Avery Stone',
  email: 'avery@example.com',
  examCode: PUBLIC_DEMO_CODE
});

export interface PublicDemoDetails {
  name: string;
  email: string;
  examCode: string;
}

export type PublicDemoErrors = Partial<Record<keyof PublicDemoDetails, string>>;

export function validatePublicDemoDetails(details: PublicDemoDetails): PublicDemoErrors {
  const errors: PublicDemoErrors = {};
  if (details.name.trim().length < 2) errors.name = 'Enter your full name using at least 2 characters.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(details.email.trim())) errors.email = 'Enter a valid email address.';
  if (details.examCode.trim().toUpperCase() !== PUBLIC_DEMO_CODE) {
    errors.examCode = 'Please use the public demo code MOCK-2026.';
  }
  return errors;
}

export function createPublicDemoCandidate(
  details: PublicDemoDetails,
  generateId: () => string = () => crypto.randomUUID()
): Candidate {
  return {
    id: generateId(),
    sessionId: generateId(),
    name: details.name.trim(),
    email: details.email.trim(),
    examCode: PUBLIC_DEMO_CODE,
    role: 'candidate',
    mode: 'public-demo'
  };
}
